import { color, snap, units } from '@m/alchemy-ui/theme';
import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';

import { Popper } from '@m/alchemy-ui/Popper';
import { PopperBox } from '@m/alchemy-ui/PopperBox';

import { useIntl } from 'react-intl';
import { type Phase } from '../../../common/core-api';
import { PhaseForm } from '.';

const StyledButton = styled(Button)`
  padding: ${units(0.5)} ${units(1.5)};
  min-height: ${units(3)};
  background-color: ${color('container')};
  border: 2px solid ${color('fill')};
`;

const PhaseFormPopper = styled(PopperBox)`
  width: ${snap(800)};

  @media all and (max-width: 1020px) {
    width: 85%;
  }
`;

export const PhaseAddButton = ({
  message,
  previousPhase,
  afterPhase
}: {
  readonly message: string;
  readonly previousPhase?: Phase;
  readonly afterPhase?: Phase;
}) => {
  const intl = useIntl();

  return (
    <Popper
      placement="bottom"
      shouldCloseOnOutsideInteraction={false}
      trigger={
        <StyledButton
          priority="tertiary"
          aria-label={`${message} ${intl.formatMessage({ id: 'phase', defaultMessage: 'Phase' })}`}
        >
          {message}
        </StyledButton>
      }
      overlay={({ setIsOpen }) => (
        <PhaseFormPopper hasArrow maxWidth={snap(800)}>
          <PhaseForm setPopperOpen={setIsOpen} previousPhase={previousPhase} afterPhase={afterPhase} />
        </PhaseFormPopper>
      )}
    />
  );
};
